var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTypeSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1213 2.37868C14.4633 2.72063 14.7213 3.30067 14.86 4.51708C14.9984 5.73148 15 7.37049 15 9.67157C15 11.199 14.9969 12.2253 14.8667 13.0203C14.7456 13.7598 14.5256 14.217 14.1213 14.6213C13.7523 14.9903 13.2342 15.2309 12.2558 15.3625C11.2487 15.4979 9.91389 15.5 8 15.5C6.08611 15.5 4.75129 15.4979 3.74416 15.3625C2.76579 15.2309 2.2477 14.9903 1.87868 14.6213C1.50966 14.2523 1.26907 13.7342 1.13753 12.7558C1.00212 11.7487 1 10.4139 1 8.5C1 6.58611 1.00212 5.25129 1.13753 4.24416C1.26907 3.26579 1.50966 2.7477 1.87868 2.37868C2.2477 2.00966 2.76579 1.76907 3.74416 1.63753C4.75129 1.50212 6.08611 1.5 8 1.5C9.91389 1.5 11.2487 1.50212 12.2558 1.63753C13.2342 1.76907 13.7523 2.00966 14.1213 2.37868ZM14.8284 1.67157C16 2.84315 16 5.11929 16 9.67157C16 12.6618 16 14.1569 14.8284 15.3284C13.6569 16.5 11.7712 16.5 8 16.5C4.22876 16.5 2.34315 16.5 1.17157 15.3284C0 14.1569 0 12.2712 0 8.5C0 4.72876 0 2.84315 1.17157 1.67157C2.34315 0.5 4.22876 0.5 8 0.5C11.7712 0.5 13.6569 0.5 14.8284 1.67157ZM7.13391 11C7.51881 11.6667 8.48106 11.6667 8.86596 11L10.8429 7.57584C11.2278 6.90917 10.7467 6.07584 9.97688 6.07584L6.023 6.07584C5.2532 6.07584 4.77207 6.90917 5.15697 7.57584L7.13391 11Z",
    fill: "#151515"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeSelect);
export default __webpack_public_path__ + "static/media/type-select.2acf6e6859506ee22ab1b97103d252ee.svg";
export { ForwardRef as ReactComponent };